import { render, staticRenderFns } from "./index8.vue?vue&type=template&id=238796fe&scoped=true"
import script from "./index8.vue?vue&type=script&lang=js"
export * from "./index8.vue?vue&type=script&lang=js"
import style0 from "./index8.vue?vue&type=style&index=0&id=238796fe&prod&lang=scss"
import style1 from "./index8.vue?vue&type=style&index=1&id=238796fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238796fe",
  null
  
)

export default component.exports